import { Modal } from 'antd';
import styled from 'styled-components';
function CustomModalStyle({...props}) {
    return (
        <Modal {...props} zIndex={4000}/>
    );
}

export const CustomModal = styled(CustomModalStyle)`
    .ant-modal-content {
        background-color: transparent;
        box-shadow: none;
        padding: 0;
        margin: 0;
    }

`;